const red: Record<string, string> = {
  50: '#fae7e9',
  100: '#f1c3c6',
  200: '#d78b87',
  300: '#c45f5a',
  400: '#c63e35',
  500: '#c42a17',
  600: '#b72018',
  700: '#a71613',
  800: '#9a0d0d',
  900: '#8b0000',
  DEFAULT: '#c42a17',
};

export default red;
